// @flow
import { SET_HEADER_VISIBLITY } from '../constants/action_types'

export const setHeaderVisibility = (visible) => ({ type: SET_HEADER_VISIBLITY, visible })
